import SmsActionTypes from './types';

const INITIAL_STATE = {
  configuration: null,
  loading: false,
  saving: false,
  error: null,
  logs: null,
  logsLoading: false,
  logsError: null,
};

const smsConfigurationReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case SmsActionTypes.FETCH_SMS_CONFIGURATION:
      return { ...state, loading: true, error: null };
    case SmsActionTypes.FETCH_SMS_CONFIGURATION_SUCCESS:
    case SmsActionTypes.UPDATE_SMS_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loading: false,
        saving: false,
        configuration: payload,
      };
    case SmsActionTypes.FETCH_SMS_CONFIGURATION_FAILURE:
    case SmsActionTypes.UPDATE_SMS_CONFIGURATION_FAILURE:
      return {
        ...state,
        loading: false,
        saving: false,
        error: payload,
      };
    case SmsActionTypes.UPDATE_SMS_CONFIGURATION:
      return { ...state, saving: true, error: null };
    case SmsActionTypes.FETCH_SMS_LOGS:
      return { ...state, logsLoading: true, logsError: null };
    case SmsActionTypes.FETCH_SMS_LOGS_SUCCESS:
      return {
        ...state,
        logsLoading: false,
        logs: payload,
      };
    case SmsActionTypes.FETCH_SMS_LOGS_FAILURE:
      return {
        ...state,
        logsLoading: false,
        logsError: payload,
      };
    default:
      return state;
  }
};

export default smsConfigurationReducer;
